"use client";

import { useSyncExternalStore } from "react";

const subscribeNoop = () => () => undefined;
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/** False on the server and while hydrating, so the first client render matches the server HTML. */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribeNoop, getClientSnapshot, getServerSnapshot);
}
